<template>
<div class="grid" >
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-3">
<div class="grid"  v-click-away="cancel">
<div class="col">

<!--
<Editor v-model="inputdata" 
editorStyle="height: 320px"
:placeholder="title"
@text-change="updateInput"
v-click-away="submitChanges"
>

<template #toolbar>
<span class="ql-formats">
    <select class="ql-header" defaultValue="0">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="0">Normal</option>
    </select>    
</span>
<span class="ql-formats">
  <button class="ql-bold"></button>
  <button class="ql-italic"></button>
  <button class="ql-underline"></button>
  <select class="ql-color" >
  </select>
  <select class="ql-background" >
  </select>
</span>
 <span class="ql-formats">
    <button class="ql-list" value="ordered" type="button"></button>
    <button class="ql-list" value="bullet" type="button"></button>
    <select class="ql-align">
        <option defaultValue></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
    </select>
</span>
 <span class="ql-formats">
    <button class="ql-link" type="button"></button>
</span>
<span class="ql-formats">
    <button class="ql-code-block" type="button"></button>
</span>


  </template>

</Editor>
-->

<textarea :id="container_id" class="w-full"></textarea>



</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing" >	
<div class="col-9 md:col-10" @click="edit">
<p class="click_edit_value animate_class truncated_text" v-html="value">

</p>
</div>
</template>

</div>	
</template>

<script>
import 'suneditor/dist/css/suneditor.min.css'
import 'suneditor/src/assets/css/suneditor.css'
import 'suneditor/src/assets/css/suneditor-contents.css'
import suneditor from 'suneditor'
import plugins from 'suneditor/src/plugins'
export default {

  name: 'ClickEditInputRichTextArea',
  props:["title","value","valkey"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
      htmldata:null,
      container_id:null,
      editor:null,     
    }
  },
  computed:{
    editorcontext()
    {
      if(this.editor)
      {
        return this.editor.getContents()
      }      
    },
  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		 console.log("value change");
  		 this.editing = false
  	},
    inputdata()
    {
      console.log("inputdata changed")

    },
    editorcontext(nevVal,oldVal)
    {
      console.log("editorcontext")
    },
  },
  mounted()
  {
    this.container_id = "container_" +  this.generateId().toString()

  },
  methods:{
    updateInput(event)
    {
      this.htmldata = event.htmlValue
    },
  	submitChanges()
  	{
      console.log(this.editor.getContents())
      let html = this.editor.getContents()
      html = html.replace('<p style="text-align: center" class="full_width"><span class="full_width" style="background-color: rgb(255, 0, 0); color: rgb(255, 255, 255); font-size: 18px;"><strong>1</strong></span></p>',)
       
      this.$emit("dataChanged",{value:html,key:this.valkey})
  		if(this.inputdata !==this.value)
  		{  			
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
    initSunEditor()
    {
      this.editor = suneditor.create(this.container_id, {
          plugins: plugins,
          buttonList: [
              ['font', 'fontSize', 'formatBlock'],
              ['paragraphStyle', 'blockquote'],
              ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
              ['fontColor', 'hiliteColor', 'textStyle'],
              ['removeFormat'],
              ['outdent', 'indent'],
              ['align', 'horizontalRule', 'list', 'lineHeight'],
              ['table' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
              /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
              ['showBlocks','codeView','save'],
              /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
          ],
          addTagsWhitelist:'*',
          pasteTagsWhitelist:"*",
          attributesWhitelist:
          {
            'all': '*'
          },
          allowedClassNames:"inputfield_flex_wrap",
          value:this.inputdata,
          height:300,
      })

    },
  	edit()
  	{
      console.log("edit")
  		this.editing = true
  		this.inputdata = this.value
      setTimeout(()=>{
        this.initSunEditor()
      })
      
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
        this.editor = null
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>